module.exports = __webpack_public_path__ + "static/media/whatconverts.529d6673.svg";